export class NativeStandardConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultProtectionMode",
            "baseName": "vaultProtectionMode",
            "type": "VaultProtectionMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStandardConfig.attributeTypeMap;
    }
    constructor() {
    }
}
